import { capitalize } from 'vue';

import i18n from '@/vueI18n';

export default class MapStyleControl {
  public clickHandler: (satellite: boolean) => void;

  onAdd(map) {
    const style = map.getStyle();
    this.isSatellite = style.name !== 'Mapbox Light';
    this.mapInternal = map;
    this.containerInternal = window.document.createElement('div');
    this.containerInternal.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
    const btn = window.document.createElement('button');
    btn.className = 'mapboxgl-ctrl-icon';
    btn.title = capitalize(i18n.global.t('actions.switchMapStyle'));
    btn.onclick = () => {
      if (this.clickHandler !== undefined) {
        this.isSatellite = !this.isSatellite;
        this.clickHandler(this.isSatellite);
      }
    };
    btn.innerHTML =
      '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" ' +
      'viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">\n' +
      '<g id="Filled_Icons_1_">\n' +
      '\t<g id="Filled_Icons">\n' +
      '\t\t<g>\n' +
      '\t\t\t<g>\n' +
      '\t\t\t\t<path d="M6.109,13.39c-1.202,0-2.332,0.467-3.182,1.318c-0.195,0.194-0.195,0.513,0,0.707l5.656,5.658\n' +
      '\t\t\t\t\tc0.195,0.195,0.512,0.195,0.707,0c1.754-1.755,1.754-4.609,0-6.364C8.441,13.857,7.312,13.39,6.109,13.39z"/>\n' +
      '\t\t\t\t<path d="M23.711,18.688l-5.648-5.666c-0.195-0.193-0.512-0.195-0.706-0.001l-1.062,1.06l-0.713-0.713l2.543-2.542\n' +
      '\t\t\t\t\tc1.209-1.209,1.287-3.133,0.26-4.497l1.231-1.232c0.707,0.186,1.244-0.352,1.244-0.951c0-0.552-0.447-1-1-1\n' +
      '\t\t\t\t\tc-0.599,0-1.134,0.532-0.951,1.244l-1.23,1.23l-0.002-0.002c-0.613-0.465-1.35-0.72-2.123-0.72\n' +
      '\t\t\t\t\tc-0.904,0-1.748,0.348-2.379,0.977l-2.542,2.543L9.924,7.711l1.06-1.062c0.194-0.195,0.192-0.511-0.001-0.706L5.316,0.294\n' +
      '\t\t\t\t\tc-0.194-0.197-0.512-0.195-0.706,0L1.791,3.119C1.596,3.313,1.596,3.631,1.792,3.825l5.659,5.654\n' +
      '\t\t\t\t\tc0.195,0.194,0.512,0.195,0.707,0l1.06-1.061l0.708,0.705l-2.227,2.227c-0.196,0.196-0.194,0.513,0,0.707l4.242,4.242\n' +
      '\t\t\t\t\tc0.193,0.193,0.509,0.198,0.707,0l2.227-2.226l0.711,0.713l-1.061,1.06c-0.195,0.195-0.194,0.512,0,0.707l5.654,5.659\n' +
      '\t\t\t\t\tc0.194,0.196,0.512,0.196,0.706,0.001l2.825-2.819C23.906,19.2,23.908,18.883,23.711,18.688z"/>\n' +
      '\t\t\t</g>\n' +
      '\t\t\t<g>\n' +
      '\t\t\t\t<path d="M1.172,22.828c-1.566-1.565-1.562-4.097,0-5.656c0.195-0.195,0.512-0.195,0.707,0c0.195,0.195,0.195,0.512,0,0.707\n' +
      '\t\t\t\t\tc-1.176,1.176-1.17,3.072,0,4.242c1.134,1.134,3.11,1.133,4.242,0c0.195-0.195,0.512-0.195,0.707,0\n' +
      '\t\t\t\t\tc0.195,0.195,0.195,0.512,0,0.707C5.266,24.391,2.735,24.394,1.172,22.828z"/>\n' +
      '\t\t\t</g>\n' +
      '\t\t\t<g>\n' +
      '\t\t\t\t<path d="M3.06,21c-0.779-0.78-0.779-2.048,0-2.828c0.195-0.195,0.512-0.195,0.707,0c0.195,0.195,0.195,0.512,0,0.707\n' +
      '\t\t\t\t\tc-0.39,0.39-0.39,1.024,0,1.414c0.391,0.39,1.023,0.39,1.414,0c0.195-0.195,0.512-0.195,0.707,0\n' +
      '\t\t\t\t\tc0.195,0.195,0.195,0.512,0,0.707C5.109,21.78,3.84,21.78,3.06,21z"/>\n' +
      '\t\t\t</g>\n' +
      '\t\t</g>\n' +
      '\t</g>\n' +
      '\t<g id="New_icons">\n' +
      '\t</g>\n' +
      '</g>\n' +
      '</svg>\n';
    btn.firstChild.style = 'width: 20px; height: 20px;margin-top: 4px;';
    this.containerInternal.appendChild(btn);
    return this.containerInternal;
  }

  onRemove() {
    this.containerInternal.parentNode.removeChild(this.containerInternal);
    this.mapInternal = undefined;
  }
}
